import B2B from 'Assets/js/Vuex/Store/actions/B2b';
import UserActions from 'Assets/js/Vuex/Store/actions/User';
import WishlistActions from 'Assets/js/Vuex/Store/actions/Wishlist';
import CartOpsActions from 'Assets/js/Vuex/Store/actions/CartOps';
import UserAnalyticsActions from 'Assets/js/Vuex/Store/actions/UserAnalytics';
import ResetActions from 'Assets/js/Vuex/Store/actions/Reset';
import Systems from 'Assets/js/Vuex/Store/actions/Systems';

export default {
  ...ResetActions,
  ...UserActions,
  ...WishlistActions,
  ...CartOpsActions,
  ...UserAnalyticsActions,
  ...B2B,
  ...Systems
};
